import React, { } from "react";
import { Skeleton } from "antd";
import Container from "../../General/Container/Container";

function MinifiedInsightsText({ loading, text }) {
    return (
        <Container className="drow fullw align-center justify-center" style={{
            marginTop: "3mm",
            marginBottom: "4mm",
            padding: "5mm 11mm 5mm 11mm",
            backgroundColor: "white",
        }}>
            {loading
                ? <Skeleton paragraph={{ rows: 4 }} active />
                : <p className="flex-1" style={{ textAlign: "justify" }}>
                    {text}
                </p>
            }
        </Container>
    );
}

export default MinifiedInsightsText;
